import { useEffect } from 'react';
import { useMotionValue, type MotionValue } from 'motion/react';

const readScrollY = () =>
  window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;

/**
 * Page scroll offset as a MotionValue. The landing scrolls on <body> (overflow-x
 * is clipped there), which Motion's useScroll does not see, so listen in the
 * capture phase to catch window and body scrolling alike. No re-renders.
 */
export function usePageScrollY(): MotionValue<number> {
  const y = useMotionValue(0);
  useEffect(() => {
    const update = () => y.set(readScrollY());
    update();
    window.addEventListener('scroll', update, { passive: true, capture: true });
    return () => window.removeEventListener('scroll', update, { capture: true } as EventListenerOptions);
  }, [y]);
  return y;
}
